export default "/icon-nav-resources.svg";